import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { RequiredWrapper } from '../../../core/formValidation';
import CarModelSelect from '../../../core/components/CarModelSelect';

const VehicleDetails = () => {
  const { register, control, watch } = useFormContext();

  // Debug: Log current vehicle values
  const vehicleValues = {
    make: watch('vehicleDetails.make'),
    model: watch('vehicleDetails.model'),
    year: watch('vehicleDetails.year'),
    color: watch('vehicleDetails.color'),
    vin: watch('vehicleDetails.vin'),
    plate: watch('vehicleDetails.plate'),
  };
  const toIntOrNull = (value) => {
    if (value === undefined || value === null) return null;
    const n = Number(value);
    return value === '' || Number.isNaN(n) ? null : parseInt(String(n), 10);
  };
  return (
    <div>
      <div className="form-group row" style={{ marginBottom: '0' }}>
        <div className="col-sm-6">
          <label>Vehicle Details</label>
        </div>
      </div>
      <CarModelSelect makeProperty="vehicleDetails.make" modelProperty="vehicleDetails.model" />
      <div className="form-group row">
        <div className="form-group col-sm-6">
          <Controller
            name="vehicleDetails.year"
            control={control}
            render={({ field: { value, onChange, ...rest } }) => (
              <RequiredWrapper value={value}>
                <input
                  className="form-control"
                  id="year"
                  type="text"
                  aria-describedby="descriptionHelp"
                  placeholder="Year"
                  data-testid="vehicleYear-reclaimation-form"
                  value={value ?? ''}
                  onChange={(e) => onChange(toIntOrNull(e.target.value))}
                  {...rest}
                />
              </RequiredWrapper>
            )}
          />
        </div>
        <div className="form-group col-sm-6">
          <RequiredWrapper value={watch('vehicleDetails.color')}>
            <input
              className="form-control"
              id="color"
              type="text"
              aria-describedby="descriptionHelp"
              placeholder="Color"
              data-testid="vehicleColor-reclaimation-form"
              {...register('vehicleDetails.color')}
            />
          </RequiredWrapper>
        </div>
        <div className="col-sm-6">
          <RequiredWrapper value={watch('vehicleDetails.vin')}>
            <input
              className="form-control"
              id="vin"
              type="text"
              aria-describedby="descriptionHelp"
              placeholder="VIN"
              data-testid="vehicleVin-reclaimation-form"
              {...register('vehicleDetails.vin')}
            />
          </RequiredWrapper>
        </div>
        <div className="form-group col-sm-6">
          <RequiredWrapper value={watch('vehicleDetails.plate')}>
            <input
              className="form-control"
              id="plate"
              type="text"
              aria-describedby="descriptionHelp"
              placeholder="Plate"
              data-testid="vehiclePlate-reclaimation-form"
              {...register('vehicleDetails.plate')}
            />
          </RequiredWrapper>
        </div>
      </div>
    </div>
  );
};

export default VehicleDetails;
